export default __webpack_public_path__ + "static/media/slider-cia-3.1c1cf0ec.jpg";